/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { SNMPInterfaceStats } from "@/api/snmp";
import { TrafficPoint } from "@/components/snmp/SNMPTrafficChart";

// Converts raw cumulative counter samples (newest-first, as returned by
// GetSNMPInterfaceStats) into per-interval traffic rates for charting.
// Negative deltas (counter reset/wraparound) are clamped to 0 rather than
// producing a nonsensical spike.
export function toTrafficPoints(stats: SNMPInterfaceStats[]): TrafficPoint[] {
  if (!stats || stats.length < 2) return [];

  const chronological = [...stats].reverse();
  const points: TrafficPoint[] = [];

  for (let i = 1; i < chronological.length; i++) {
    const prev = chronological[i - 1];
    const cur = chronological[i];
    const dtSeconds =
      (new Date(cur.createdAt).getTime() - new Date(prev.createdAt).getTime()) / 1000;
    if (dtSeconds <= 0) continue;

    const inDelta = cur.inOctets - prev.inOctets;
    const outDelta = cur.outOctets - prev.outOctets;

    points.push({
      time: cur.createdAt,
      in: inDelta > 0 ? inDelta / dtSeconds : 0,
      out: outDelta > 0 ? outDelta / dtSeconds : 0,
    });
  }

  return points;
}
